import { ensureFingerprint, getFingerprint } from './fingerprint';
import { ensureDeviceUaHash, getDeviceUaHash } from './deviceUa';

const COOKIE_NAME = 'imagecat_vid';

let identityReady: Promise<void> | null = null;

/** Сервер выставляет HttpOnly-cookie через /api/visitping или /api/like. */
async function ensureServerCookie(): Promise<void> {
  const r = await fetch('/api/visitping', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: '{}',
  });
  if (!r.ok) {
    throw new Error('visitping failed');
  }
}

/** Cookie + fingerprint до любых API-запросов с лайками. */
export function initVisitorIdentity(): Promise<void> {
  if (!identityReady) {
    identityReady = (async () => {
      await ensureServerCookie();
      await Promise.all([ensureFingerprint(), ensureDeviceUaHash()]);
    })();
  }
  return identityReady;
}

/** Только fingerprint — visitor id живёт в HttpOnly cookie. */
export function visitorHeaders(): Record<string, string> {
  const headers: Record<string, string> = {};
  const fp = getFingerprint();
  if (fp) {
    headers['X-Imagecat-Fingerprint'] = fp;
  }
  const ua = getDeviceUaHash();
  if (ua) {
    headers['X-Imagecat-Ua'] = ua;
  }
  return headers;
}

export { COOKIE_NAME };
